import { Box, Center } from '@mantine/core';
import { ProgressBar } from './Progress';

type Props = {
  children: React.ReactNode;
  isLoading?: boolean;
};

export function MainContainer({ children, isLoading }: Props) {
  return (
    <>
      {isLoading && <ProgressBar />}
      <Center>
        <Box w="100%" maw="1000px" mx="md" my="lg">
          {children}
        </Box>
      </Center>
    </>
  );
}
